export const convertToString = msg => {
  if (typeof msg === 'string') {
    return msg;
  } else if (msg instanceof Error) {
    return (
      msg.message || 'An unknown error occurred. Please try again or contact customer service.'
    );
  } else {
    return 'An unknown error occurred. Please try again or contact customer service.';
  }
};
